<!-- Created by henian.xu on 2020/5/26. -->

<template>
    <Container>
        <!--{{tabIndex}}
        {{tabShowed}}-->
        <List
            class="ma-t"
            padding
            margin
        >
            <LearningCodeItem
                v-for="item in listData"
                :key="item.id"
                :data="item"
            />
        </List>
        <Pagination
            ref="infinite"
            :disabled="paginationDisabled"
            @load="onload"
        />
    </Container>
</template>

<script>
import { paginationMixin } from 'mixins/index';

export default {
    name: 'LearningCodeList',
    mixins: [paginationMixin],
    data() {
        return {};
    },
    props: {
        codeStatus: {
            type: String,
            required: true,
        },
    },
    methods: {
        async getListData(params) {
            const { codeStatus } = this;
            const res = await this.$api.Member.Mb.Enterprise.discountCodeList({
                codeStatus,
                ...params,
            });
            this.listData.push(...res.data);
            return res;
        },
    },
};
</script>

<style lang="scss">
</style>
